
export class LogEntity {
  corpId: number;
  managerId: number;
  tutorId: number;
  professorId: number;
  dateTime: string;
  ip: string;
  url: string;
  device: string;
  body: string;

  constructor() {
  }

}
